import pluralize from 'pluralize';
import { LimitsLocationIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GeoLimitSummary(_ref) {
  let {
    className,
    limit,
    schema
  } = _ref;
  return limit && /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [/*#__PURE__*/_jsx(LimitSummaryIcon, {
      as: LimitsLocationIcon
    }), ' ', /*#__PURE__*/_jsxs(LimitSummaryLimit, {
      children: ["Restricted to ", pluralize('region', limit.coordinates?.length, true)]
    })]
  });
}